import React, { useState, useEffect, Fragment } from "react";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import Layout from "components/sales/layout/layout";
import FormSection from "components/sales/formSection/formSectionNew";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";

const UpdateSupervisorListing = ({ 
    match, 
    history, 
    updateSupervisorListData ,
    getSupervisorListData,
    supervisorListData = []
}) => {
  const inputs = {
    days_off: [{}],
    blocking_amount: "",
    half_day_min_hour: "",
    full_day_min_hour: "",
  };
  const DAYS_MAP = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
  };
  const [formData, setFormData] = useState(inputs);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [offDay, setOffDay] = useState([])

  useEffect(() => {
    (async () => {
        setIsLoading(true)
        await getSupervisorListData({user_id: match?.params?.user_id}, 1)
        setIsLoading(false)
    })();
}, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData);
        const offDays = [];

        offDay.map( (val, index) => {
            offDays[index] = val.id
        })
        const payload = {
        action: 'update',
        user_id: match?.params?.user_id,
        days_off: offDays,
        blocking_amount: formData?.blocking_amount,
        half_day_min_hour: formData?.half_day_min_hour,
        full_day_min_hour: formData?.full_day_min_hour
        };

        // console.log("Testing:", payload)
        // return false;
        setIsLoading(true);
        const res = await updateSupervisorListData(payload);
        setIsLoading(false);
        if (res?.message === "Success") { 
          setIsModal(true);
        }
        setIsLoading(false);
    };

  const handleModalHide = () => {
    setIsModal(false);
  };

  useEffect(() => {
    if(supervisorListData?.resultSets && supervisorListData?.resultSets[0] && Object.keys(supervisorListData?.resultSets[0]).length > 0){
      supervisorListData?.resultSets[0]?.days_off?.map((val, i) => {
        formData['days_off'][i] = {id: parseInt(val), name: DAYS_MAP[val]};  
      })
      formData['half_day_min_hour'] = supervisorListData?.resultSets[0]['half_day_min_hour'];
      formData['full_day_min_hour'] = supervisorListData?.resultSets[0]['full_day_min_hour'];
      console.log(formData)
      setFormData(formData)
    }
}, [supervisorListData])

  return (
    <Layout title={"Supervisor Details"} isGoback isLoading={isLoading}>
      <FormSection title={"Update Details"}>
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
                data={[
                    {id: 0, name: 'Sunday'},
                    {id: 1, name: 'Monday'},
                    {id: 2, name: 'Tuesday'},
                    {id: 3, name: 'Wednesday'},
                    {id: 4, name: 'Thursday'},
                    {id: 5, name: 'Friday'},
                    {id: 6, name: 'Saturday'}
                ]}
                label={'Days Off'}
                errorMsg={'Days off is required'}
                multipule={true}
                getIdValue={(val) => {
                    setOffDay(val)
                }}
                isStarRequired={true}
                selectedList={formData?.days_off}
            />
          </div>
          {/* <div className="col-md-6">
            <ConstantInput
              value={formData.blocking_amount}
              label={"Blocking Amount"}
              errorMsg={"Blocking amount is required"}
              type="number"
              required
              handleChange={(value) =>
                setFormData({ ...formData, blocking_amount: value })
              }
              isStarRequired={true}
              fullWidth
            />
          </div> */}
          <div className="col-md-6">
            <ConstantInput
              label={"Half Day Min. Hour"}
              errorMsg={"Half day min. hours are required"}
              type="number"
              required
              handleChange={(value) =>
                setFormData({ ...formData, half_day_min_hour: value })
              }
              isStarRequired={true}
              fullWidth
              value={formData?.half_day_min_hour}
            />
          </div>
          <div className="col-md-6">
            <ConstantInput
              label={"Full Day Min. Hour"}
              errorMsg={"Full day min. hours are required"}
              type="number"
              required
              handleChange={(value) =>
                setFormData({ ...formData, full_day_min_hour: value })
              }
              isStarRequired={true}
              fullWidth
              value={formData?.full_day_min_hour}
            />
          </div>
        </div>

        <div className="col-md-4">
          <button className="btn btn-sm btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </FormSection>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{'Valet details updated successfully'}</h5>
          <Link
            to={`${baseUrl}/all-supervisor-listing`}
            className="btn btn-primary mb-4"
          >
            Supervisor List <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default UpdateSupervisorListing;
